import React from 'react';
import { translate } from 'react-polyglot';
import { connect } from 'react-redux';
import './SectionBanner.scss';
import { SECTION_BANNER_TYPES } from '../../constants/constants';
import SectionBannerIntro from './components/SectionBannerIntro';
import SectionBannerSignup from './components/SectionBannerSignup';
import SectionBannerAffiliation from './components/SectionBannerAffiliation';
import withRouter from '../../util/withRouter';
const SectionBanner = ({ t, bannerType, navigate, isLoggedIn }) => {
    const baseClassName = 'section-banner';

    return (
        <div className={`${baseClassName}`}>
            {bannerType
                ? {
                      [SECTION_BANNER_TYPES.intro]: (
                          <SectionBannerIntro
                              t={t}
                              baseClassName={baseClassName}
                          />
                      ),
                      [SECTION_BANNER_TYPES.signUp]: isLoggedIn ? null : (
                          <SectionBannerSignup
                              t={t}
                              baseClassName={baseClassName}
                              navigate={navigate}
                          />
                      ),
                      [SECTION_BANNER_TYPES.affiliation]: (
                          <SectionBannerAffiliation
                              t={t}
                              baseClassName={baseClassName}
                          />
                      ),
                  }[bannerType]
                : null}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.user.isLoggedIn,
    };
};

const mapDispatchToProps = {};

export default withRouter(
    translate()(connect(mapStateToProps, mapDispatchToProps)(SectionBanner))
);
